<template>
	<span class="hover-card-wrapper">
		<HoverCard.Root
			:positioning="positioning"
			:open-delay="openDelay"
			:close-delay="closeDelay"
			:open="open"
			@update:open="$emit('update:open', $event)"
		>
			<HoverCard.Trigger as-child>
				<slot name="trigger" />
			</HoverCard.Trigger>
			<HoverCard.Positioner>
				<HoverCard.Content class="content">
					<HoverCard.Arrow v-if="showArrow" class="arrow">
						<HoverCard.ArrowTip class="arrow-tip" />
					</HoverCard.Arrow>
					<slot />
				</HoverCard.Content>
			</HoverCard.Positioner>
		</HoverCard.Root>
	</span>
</template>

<script setup lang="ts">
import { HoverCard } from "@ark-ui/vue"
import type { HoverCardRootProps } from "@ark-ui/vue"

withDefaults(
	defineProps<{
		positioning?: HoverCardRootProps["positioning"]
		openDelay?: number
		closeDelay?: number
		showArrow?: boolean
		open?: boolean
	}>(),
	{
		positioning: () => ({ placement: "bottom", gutter: 8 }),
		openDelay: 400,
		closeDelay: 200,
		showArrow: false,
		open: undefined,
	}
)

defineEmits<{
	"update:open": [value: boolean]
}>()
</script>

<style scoped>
.hover-card-wrapper {
	display: contents;

	.content {
		z-index: 10;
		box-shadow: var(--shadow-lg);
		border-radius: var(--border-radius-base);
		background-color: var(--neutral-0);
		max-width: var(--min-width-container);
		border: var(--border-width-thin) solid var(--neutral-50);
	}

	:deep(.content img) {
		max-width: 100%;
		height: auto;
	}

	.arrow {
		--arrow-size: var(--space-8);
		--arrow-background: var(--neutral-0);
	}

	.arrow-tip {
		border-top: var(--border-width-thin) solid var(--neutral-50);
		border-left: var(--border-width-thin) solid var(--neutral-50);
	}
}
</style>
